import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function ServiceRecords() {
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    (async () => {
      const vehicles = await api(`/vehicles`).then(r => r.json());
      const all = await Promise.all(vehicles.map(async (v) => {
        const recs = await api(`/vehicles/${v.id}/service-records`).then(r => r.json()).catch(() => []);
        return recs.map(r => ({ ...r, vehicleName: `${v.year} ${v.make} ${v.model}` }));
      }));
      setRecords(all.flat());
    })();
  }, []);

  const filtered = records.filter(r =>
    `${r.vehicleName} ${r.serviceType} ${r.shop || ''}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const statusColor = (status) => ({
    'Completed': 'bg-green-100 text-green-800',
    'In Progress': 'bg-yellow-100 text-yellow-800',
    'Scheduled': 'bg-blue-100 text-blue-800',
  }[status] || 'bg-gray-100 text-gray-800');

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Service Records</h1>
          </div>
          <input
            type="text"
            placeholder="Search by vehicle, service type, or shop..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Vehicle</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Service Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Mileage</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cost</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filtered.map((r) => (
                <tr key={r.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                    <Link to={`/vehicles/${r.vehicleId}`} className="hover:text-purple-600">{r.vehicleName}</Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{r.serviceType}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{r.serviceDate}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{r.mileage?.toLocaleString()}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{r.cost != null ? `$${r.cost.toFixed(2)}` : '—'}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${statusColor(r.status)}`}>
                      {r.status || '—'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <Link to={`/vehicles/${r.vehicleId}`} className="text-purple-600 hover:text-purple-800 font-medium">View Vehicle</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div className="text-center py-12 text-gray-500">No service records found.</div>
          )}
        </div>
      </div>
    </Layout>
  );
}
